import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Facebook, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-green-dark text-brand-cream" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="font-display text-3xl font-semibold">
            SDRC <span className="text-brand-gold">Global</span>
          </div>
          <p className="mt-4 text-sm text-brand-cream/70 leading-relaxed max-w-xs">
            From Indian Farms to Global Markets. Premium millet, wheat &amp; agri-commodity exporter delivering quality, transparency and trust worldwide.
          </p>
          <div className="flex gap-4 mt-6">
            {[Linkedin, Twitter, Facebook].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`social-${i}`}
                className="w-9 h-9 rounded-full border border-brand-cream/20 flex items-center justify-center hover:border-brand-gold hover:text-brand-gold transition-colors"
                aria-label="social link"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm text-brand-cream/80">
            <li><Link to="/products" className="hover:text-brand-gold transition-colors">Products</Link></li>
            <li><Link to="/millet-export" className="hover:text-brand-gold transition-colors">Millet Export Guide</Link></li>
            <li><Link to="/resources" className="hover:text-brand-gold transition-colors">Buyer Resources</Link></li>
            <li><Link to="/millet-export/pearl-millet-bajra" className="hover:text-brand-gold transition-colors">Pearl Millet &amp; Bajra</Link></li>
            <li><Link to="/about" className="hover:text-brand-gold transition-colors">About Us</Link></li>
            <li><Link to="/food-safety" className="hover:text-brand-gold transition-colors">Food Safety Licenses</Link></li>
            <li><Link to="/contact" className="hover:text-brand-gold transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold mb-5">Get in Touch</h4>
          <ul className="space-y-3 text-sm text-brand-cream/80">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-brand-gold shrink-0" /> A559 Second Floor, Palam Vihar Sector 2, Gurugram 122017</li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-brand-gold shrink-0" /> +91-9928845789</li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-brand-gold shrink-0" /> sales@sdrcglobal.com</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold mb-5">Legal</h4>
          <ul className="space-y-3 text-sm text-brand-cream/80">
            <li><a href="#" className="hover:text-brand-gold transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-brand-gold transition-colors">Terms &amp; Conditions</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-cream/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-cream/60">
          <span>© {new Date().getFullYear()} SDRC Global. All rights reserved.</span>
          <span>Pearl Millet Exporter India · Bajra Exporter · Agricultural Commodity Exporter</span>
        </div>
      </div>
    </footer>
  );
}
